import React from 'react'
import { Mono, MqDesktop, MqTablet } from 'streamr-ui/css/consts'
import styled from 'styled-components'
import SocialLinks from './SocialLinks'

const Inner = styled.div`
    display: flex;
    margin-top: 1.5rem;

    @media ${MqDesktop} {
        margin-top: 0;
    }
`

const Personage = styled.div`
    flex: 1;
`

const Name = styled.div`
    color: #0c009a;
    font-size: 1.25rem;
    line-height: 2rem;

    @media ${MqTablet} {
        font-size: 1.125rem;
    }

    @media ${MqDesktop} {
        font-size: 1.25rem;
    }
`

const Title = styled.div`
    color: #adadad;
    font-family: ${Mono};
    font-size: 0.75rem;
    letter-spacing: 1px;
    line-height: 1.5rem;
    text-transform: uppercase;

    @media ${MqDesktop} {
        font-size: 0.875rem;
        letter-spacing: 2px;
    }
`

const Desc = styled.div`
    color: #0c009a;
    line-height: 1.5em;
    padding: 1rem 0;

    span {
        font-size: 0.875em;
    }

    @media ${MqTablet} {
        font-size: 0.875rem;
        line-height: 1.375rem;
    }

    @media ${MqDesktop} {
        font-size: 1.125rem;
        line-height: 1.875rem;
        padding: 2rem 0 0;

        span {
            font-size: 1em;
        }
    }
`

const UnstyledBio = ({ className, member, children }) => {
    return (
        <div className={className} $appearIntersection>
            <Inner>
                <Personage>
                    <Name $appear>{member.name}</Name>
                    <Title $appear>{member.role}</Title>
                </Personage>
                <SocialLinks
                    $appearDirection="none"
                    desktop
                    email={member.email}
                    linkedin={member.linkedin}
                    twitter={member.twitter}
                    website={member.website}
                />
            </Inner>
            <Desc $appear>{member.description}</Desc>
            <SocialLinks
                $appearDirection="none"
                mobile
                email={member.email}
                linkedin={member.linkedin}
                twitter={member.twitter}
                website={member.website}
            />
            {children}
        </div>
    )
}

const Bio = styled(UnstyledBio)`
    backface-visibility: hidden;
    font-size: 1rem;
`

export default Bio
